// Coloris configuration
import { getThemeSwatches } from './theme_colors'

function getSwatches() {
  const swatches = []

  getThemeSwatches().forEach(({ value }) => swatches.push(value))

  // Add a transparent separator to create visual space (appears as empty swatch)
  if (swatches.length > 0) {
    swatches.push('transparent')
  }

  // Add default Bootstrap colors
  swatches.push(
    '#ffffff', // White
    '#000000', // Black
    '#0d6efd', // Primary (Blue)
    '#6610f2', // Indigo
    '#6f42c1', // Purple
    '#d63384', // Pink
    '#dc3545', // Danger (Red)
    '#fd7e14', // Orange
    '#ffc107', // Warning (Yellow)
    '#198754', // Success (Green)
    '#20c997', // Teal
    '#0dcaf0'  // Info (Cyan)
  )

  return swatches
}

export const colorisConfig = {
  el: '.coloris-input',
  theme: 'large',
  themeMode: 'dark',
  closeButton: true,
  get swatches() {
    return getSwatches()
  }
}
